
    import { Component, Prop, Vue } from 'vue-property-decorator'
    import 'prismjs'
    import Prism from 'vue-prism-component'

    @Component({
        components: {
            Prism
        }
    })
    export default class LanguageInfo extends Vue {
        @Prop() private language!: string;
        @Prop() private prismLanguage!: string;
        @Prop() private library!: string;
        @Prop() private snippetPath!: string;
        snippetBaseContent: string = "";

        @Prop() private userAgent!: string;
        @Prop() private url!: string;

        get prismLang() {
            return (this.prismLanguage || this.language || 'markup').toLowerCase()
        }

        get urlHost() {
            return new URL(this.url).host;
        }

        get urlPath() {
            return new URL(this.url).pathname;
        }

        get formattedSnippet() {
            return this.snippetBaseContent
                .replace(/%%url%%/gi, this.url)
                .replace(/%%urlhost%%/gi, this.urlHost)
                .replace(/%%urlpath%%/gi, this.urlPath)
                .replace(/%%useragent%%/gi, this.userAgent);
        }

        mounted(): void {
            fetch("/snippets/" + this.snippetPath).then(res=>res.text()).then(snippet=>{
                this.snippetBaseContent = snippet;
            })
        }
    }
